import styled from '@emotion/styled';
import { forwardRef } from 'react';

import { Glyph } from '../common/Glyph';

import { MonoButton } from './MonoButton';

export const MonoButtonRound = forwardRef((props, ref) => {
  return <MonoButton {...props} ref={ref} styleRound={true} />;
});

MonoButtonRound.propTypes = MonoButton.propTypes;

MonoButtonRound.Text = styled.span`
  white-space: nowrap;
`;

MonoButtonRound.Icon = Glyph;
